import { engineComponent } from "neo-common";
import { ComponentTypes } from "./ComponentTypes";

/**
 * Configuration hold elements configurations from xml by ID.
 * @class Configuration
 */
@engineComponent(ComponentTypes.Element)
export class Configuration {
    static Configurations: { [id: string]: Element } = {};
}

export const GeneralConfigurationAttributes = {
    /**
     * ReelCount is count of reels on screen for game.
     * @property ReelCount
     * @type Number
     * @default null
     */
    REEL_COUNT: "ReelCount",
    /**
     * ReelX is array of x position for reels.
     * @property ReelX
     * @type Array<number>
     * @default null
     */
    REEL_X: "ReelX",
    /**
     * ReelY is array of y position for reels.
     * @property ReelY
     * @type Array<number>
     * @default null
     */
    REEL_Y: "ReelY",
    /**
     * Standard symbol width without offsets.
     * @property SymbolWidth
     * @type number
     * @default null
     */
    SYMBOL_WIDTH: "SymbolWidth",
    /**
     * Standard symbol height without offsets.
     * @property SymbolHeight
     * @type number
     * @default null
     */
    SYMBOL_HEIGHT: "SymbolHeight",
    /**
     * Number of symbols visible on reel.
     * @property VisibleSymbolCount
     * @type number
     * @default null
     */
    VISIBLE_SYMBOL_COUNT: "VisibleSymbolCount",
    /**
     * Wins multipliers (need WinsAnimations with same array length).
     * @property WinsMultipliers
     * @type Array<number>
     * @default null
     */
    WINS_MULTIPLIERS: "WinsMultipliers",
    /**
     * Wins animations (need WinsMultipliers with same array length).
     * @property WinsAnimations
     * @type Array<string>
     * @default null
     */
    WINS_ANIMATIONS: "WinsAnimations",
};

export const ReelConfigurationAttributes = {
    /**
     * Pre roll height in pixels.
     * @property PreRoll
     * @type number
     * @default 180
     */
    PRE_ROLL: "PreRoll",
    /**
     * Pre roll speed in frames.
     * @property PreRollSpeed
     * @type number
     * @default 10
     */
    PRE_ROLL_SPEED: "PreRollSpeed",
    /**
     * Post roll height in pixels.
     * @property PostRoll
     * @type number
     * @default 180
     */
    POST_ROLL: "PostRoll",
    /**
     * Post roll speed in frames.
     * @property PostRollSpeed
     * @type number
     * @default 5
     */
    POST_ROLL_SPEED: "PostRollSpeed",
    /**
     * Speed of rotation in frames.
     * @property Speed
     * @type number
     * @default 3
     */
    SPEED: "Speed",
    /**
     * Multiplier for force speed.
     * @property ForceSpeedMultipler
     * @type number
     * @default 1.5
     */
    FORCE_SPEED_MULTIPLER: "ForceSpeedMultipler",
};

export const MachineConfigurationAttributes = {
    /**
     * Min spin rotation in frames.
     * @property MinSpinRotation
     * @type number
     * @default 40
     */
    MIN_SPIN_ROTATION: "MinSpinRotation",
    /**
     * Min spin rotation in frames for outro high wins.
     * @property MinSpinRotationLong
     * @type number
     * @default 100
     */
    MIN_SPIN_ROTATION_LONG: "MinSpinRotationLong",
    /**
     * Delay to start rotation in frames.
     * @property StartDelay
     * @type number
     * @default 3
     */
    START_DELAY: "StartDelay",
    /**
     * Delay to stop rotation in frames.
     * @property StopDelay
     * @type number
     * @default 10
     */
    STOP_DELAY: "StopDelay",
    /**
     * Configuration ID for reels.
     * @property StopDelay
     * @type string
     * @default null
     */
    REEL_CONFIGURATION: "ReelConfiguration",
    /**
     * Teasings defined array of symbols which will go after reel stopped to teaser state.
     * @property Teasings
     * @type Array<number>
     * @default null
     *
     * @deprecated Use TeasingSymbols istead Teasing
     */
    TEASINGS: "Teasings",
    /**
     * Teasings defined array of symbols which will go after reel stopped to teaser state.
     * @property Teasings
     * @type Array<number>
     * @default null
     */
    TEASING_SYMBOLS: "TeasingSymbols",
    /**
     *
     */
    TEASING_STOP_DELAY: "TeasingStopDelay",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Configuration.ts
 **/